{
  "generic": {
    "no": "Ei",
    "yes": "Kyllä",
    "text": "Teksti "
  },
  "consent": {
    "defaultLabelText": "Lähettämällä tämän lomakkeen hyväksyt ",
    "defaultLabelLink": "tietosuojakäytäntö"
  },
  "text": {
    "defaultHeadlineText": "Tämä on otsikko",
    "defaultText": "Tämä on tekstilohko",
    "floatingDefaultText": "UUSI!"
  },
  "button": {
    "submitDefaultText": "Lähetä",
    "instagramDefaultText": "Seuraa meitä",
    "defaultText": "Klikkaa tästä",
    "closing": "SULKEMINEN..."
  },
  "input": {
    "emailLabel": "Sähköposti",
    "emailPlaceholder": "Syötä sähköpostiosoitteesi",
    "passwordLabel": "Salasana",
    "passwordPlaceholder": "Syötä salasana",
    "nameLabel": "Nimi",
    "namePlaceholder": "Syötä nimesi",
    "firstNameLabel": "Etunimi",
    "firstNamePlaceholder": "Syötä etunimi",
    "lastNameLabel": "Sukunimi",
    "lastNamePlaceholder": "Syötä sukunimi",
    "phoneLabel": "Puhelin",
    "phonePlaceholder": "Syötä puhelinnumero",
    "textareaLabel": "Viesti",
    "textareaPlaceholder": "Syötä viestisi",
    "regularLabel": "Teksti",
    "regularPlaceholder": "Syötä teksti",
    "defaultLabel": "Tunniste",
    "defaultPlaceholder": "Paikkamerkki",
    "datePlaceholder": "Valitse päivämäärä",
    "stepLabel": "Syötä kysymyksesi tähän"
  },
  "dropdown": {
    "placeholder": "Valitse vaihtoehto",
    "firstItem": "Vaihtoehto 1",
    "secondItem": "Vaihtoehto 2",
    "chooseCountry": "Maa"
  },
  "buttonList": {
    "firstItem": "Vaihtoehto 1",
    "secondItem": "Vaihtoehto 2",
    "option1": "Valinta 1",
    "option2": "Valinta 2",
    "option3": "Valinta 3",
    "subscriptionItem1": "Uutiskirje",
    "subscriptionItem2": "Päivitykset",
    "chooseSubscriptionTopics": "Valitse tilausaiheet",
    "other": "Muu",
    "uncheck-all-label": "En halua vastaanottaa mitään näistä sähköposteista"
  },
  "rating": {
    "rateLabel": "Arvostele meidät",
    "npsLabel": "Kuinka todennäköisesti suosittelisit meitä?",
    "veryUnsatisfied": "Erittäin tyytymätön",
    "unsatisfied": "Tyytymätön",
    "neutral": "Neutraali",
    "satisfied": "Tyytyväinen",
    "loveIt": "Rakastan sitä!",
    "minValueLabel": "Matala",
    "maxValueLabel": "Korkea",
    "minValueLabelNps": "Ei todennäköistä",
    "maxValueLabelNps": "Erittäin todennäköistä"
  },
  "deadline": {
    "days": "Päivät",
    "hours": "Tunnit",
    "minutes": "Minuutit",
    "seconds": "Sekunnit"
  },
  "bulletList": {
    "firstItem": "Etu 1",
    "secondItem": "Etu 2"
  },
  "discountCode": {
    "copyMessage": "Kopioitu leikepöydälle!",
    "fallback": "WELCOME10",
    "textDefault": "Alennuskoodisi",
    "buttonDefault": "Kopioi"
  },
  "share": {
    "buttonText": "Jaa"
  },
  "common": {
    "label": "Tunniste"
  },
  "wcag": {
    "banner": "Mainosbanneri",
    "closeButton": "Sulje",
    "submitButton": "Lähetä lomake"
  },
  "spinTheWheel": {
    "prizeWonText": "Onnittelut!",
    "prizeWonButtonText": "Lunasta palkintosi",
    "prizeLostText": "Voi ei, harmi! :-(",
    "prizeLostButtonText": "Klikkaa sulkeaksesi",
    "spinButtonLabel": "PYÖRÄYTÄ"
  },
  "memory": {
    "resultWonText": "Hyvä työ! Aikasi oli {elapsedTime}",
    "resultWonButtonText": "Lunasta palkintosi"
  },
  "stepNavigation": {
    "nextButtonText": "Seuraava",
    "previousButtonText": "Takaisin",
    "lastButtonText": "Sulje",
    "submitButtonText": "Lähetä"
  },
  "defaultRealTimeMessage": {
    "validationError": "Tarkista lähettämiesi tietojen muoto.",
    "unknownError": "Lähettämisessä tapahtui odottamaton ongelma.",
    "conflictError": "Tämä käyttäjä on jo olemassa.",
    "success": "Lomake lähetetty."
  }
}
